import React from 'react';
import { ReasonsToShopWithUs } from 'src/components/ReasonsToShopWithUs/ReasonsToShopWithUs';

export default function ReasonsSection() {
    return <ReasonsToShopWithUs />;
}
